import { render } from "./Spare.vue?vue&type=template&id=c04fb39e&scoped=true"
import script from "./Spare.vue?vue&type=script&lang=js"
export * from "./Spare.vue?vue&type=script&lang=js"

import "./Spare.vue?vue&type=style&index=0&id=c04fb39e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04fb39e"]])

export default __exports__